const LayoutDefault = () => import('@/layout/Default');

const SellableStudentExam = () => import('@/views/SellableStudentExam/Index');

export default {
  path: '/simulados-avulsos',
  component: LayoutDefault,
  children: [
    {
      path: '',
      name: 'SellableStudentExam',
      component: SellableStudentExam,
    },
  ],
};
